import {SureFlowLoopInitial} from '../model/sure-flow-loop-initial';
import {SureFlowLoopDetail} from '../model/sure-flow-loop-detail';
import {UnitConversionUtils} from '../configurator/unit-conversion-utils';

export class SureflowUnitUtils {

  static createLoopDetail(input: SureFlowLoopInitial): SureFlowLoopDetail {
    const detail: SureFlowLoopDetail = new SureFlowLoopDetail();
    detail.systemTypeCode = input.systemTypeCode;
    detail.metric = input.metric;
    detail.description = input.description;
    if (input.coolingPipeId > 0) {
      detail.coolingFluidTypeCode = input.coolingFluidTypeCode;
      detail.coolingGlycolPercentage = input.coolingGlycolPercentage;
      detail.coolingPipeId = input.coolingPipeId;
      detail.coolingPeakFluidFlowRate = input.metric ? SureflowUnitUtils.convertAndRoundFlowRate(5, true) : 5;
      detail.coolingPeakFluidFlowRateLocked = true;
      detail.coolingTargetSensibleHeatRatio = 80;
      detail.coolingEnteringFluidTemperature = input.metric ? SureflowUnitUtils.convertAndRoundTemperature(45, true) : 45;
    }
    if (input.heatingPipeId > 0) {
      detail.heatingFluidTypeCode = input.heatingFluidTypeCode;
      detail.heatingGlycolPercentage = input.heatingGlycolPercentage;
      detail.heatingPipeId = input.heatingPipeId;
      detail.heatingPeakFluidFlowRate = input.metric ? SureflowUnitUtils.convertAndRoundFlowRate(5, true) : 5;
      detail.heatingPeakFluidFlowRateLocked = true;
      detail.heatingEnteringFluidTemperature = input.metric ? SureflowUnitUtils.convertAndRoundTemperature(180, true) : 180;
    }
    return detail;
  }

  static convertAndRoundFlowRate(value: number, isMetric: boolean): number {
    const convertedValue = +UnitConversionUtils.convertFlowRate(value, isMetric);
    return SureflowUnitUtils.round(convertedValue, 1);
  }

  static round(input: number, digits: number): number {
    const rounded: string = input.toFixed(1);
    return +rounded;
  }

  static convertAndRoundTemperature(value: number, isMetric: boolean): number {
    const convertedValue = +UnitConversionUtils.convertTemperatureValue(value, isMetric);
    return SureflowUnitUtils.round(convertedValue, 1);
  }


}
